import React, {forwardRef, useEffect, useImperativeHandle, useRef} from 'react';

type SidePanelProps = {
  children: React.ReactNode;
  width?: number;
  onClose: () => void;
  visible: boolean;
  marginTop?: number;
};

export type SidePanelRef = {
  open: () => void;
  close: () => void;
};

const SidePanel = forwardRef<SidePanelRef, SidePanelProps>(
  ({children, width = 440, onClose, visible, marginTop = 0}, ref) => {
    const screenWidth = window.innerWidth;
    const visibleValue = useRef(false);
    const panelWidth = screenWidth > width ? width : screenWidth;

    useImperativeHandle(
      ref,
      () => ({
        open: () => {
          visibleValue.current = true;
        },
        close: () => {
          visibleValue.current = false;
          setTimeout(() => {
            onClose();
          }, 0);
        }
      }),
      []
    );

    useEffect(() => {
      visibleValue.current = visible;
    }, [visible]);

    return (
      <div
        className={`flex-1 absolute left-0 top-0 bottom-0 bg-[#030015] z-[99] ${
          visible ? 'slideinleft' : 'panel-hidden'
        }`}
        style={{
          width: panelWidth, 
          marginTop
        }}
      >
        {children}
      </div>
    );
  }
);

SidePanel.displayName = 'SidePanel';

export default SidePanel;
